import TB from '@tiger/bridge';
import devtools from '@tiger/devtools';
import { Logger } from '@tiger/logger';
import { createRoot, Root } from 'react-dom/client';
import App from 'modules/App';
import { context } from 'modules/App/context';
import APPStore from 'stores/APP';
import { preloadCG } from 'utils/API';
import '@tiger/ads';
import '@tiger/share/dist/share.css';

// 移动端或者app内
if (APPStore.isMobile || APPStore.isTiger) {
    devtools({
        smart: true,
        tool: 'all'
    });
}

if (!__DEV__) {
    // 生产环境关闭日志输出
    Logger.config({
        logLevels: []
    });
}

let root: Root;

export function mount(container: HTMLElement, isEmbedded: boolean = true) {
    TB.ready.then(
        () => {
            // 禁用安卓右滑手势退出
            TB.setExitSliderEnable(false);
        },
        () => {}
    );

    root = createRoot(container);

    preloadCG().then(() => {
        root.render(
            <context.Provider value={{ isEmbedded }}>
                <App />
            </context.Provider>
        );
    });
}

export function unmount() {
    root && root.unmount();
}

if (window.gtag) {
    window.gtag('config', 'G-2D5SRG5MHE', {
        app_name: window.navigator.appCodeName,
        app_version: window.navigator.userAgent
    });

    window.gtag('event', 'screen_view', {
        screen_name: window.navigator.platform,
        screen_height: window.screen.height,
        screen_width: window.screen.width
    });
}
